import { render, staticRenderFns } from "./AdminDetectionPointDetail.vue?vue&type=template&id=faa3c3c0&scoped=true"
import script from "./AdminDetectionPointDetail.vue?vue&type=script&lang=js"
export * from "./AdminDetectionPointDetail.vue?vue&type=script&lang=js"
import style0 from "./AdminDetectionPointDetail.vue?vue&type=style&index=0&id=faa3c3c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa3c3c0",
  null
  
)

export default component.exports